/**
 * Created by Carsten Bühler
 * User: CBuehler on 09.11.2015
 * Copyright: xdot GmbH 2015
 */


import { Client } from 'external/lwr-client';
import { ApiUtil } from 'plugin/liferay-widgets-react-web';

const baseService = (m, o) => Client.invoke('/base.referencevalue/' + m, o);
//const baseServiceWithContext = (m, o, c) => Client.invokeWithContext('/base.namedprop/' + m, o, c);

const api = {

    getReferenceValuesByDataTypeNotExpired(query) {
        return baseService('get-reference-values-by-data-type-not-expired.3',{
            className: query.className,
            classPK: query.classPK,
            dataType: query.dataType
        });
    }

};


ApiUtil.namedApi('ReferenceValueWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/ReferenceValueWebApi.js